<template>
  <div>
    <v-btn text color="blue" @click="getDoc">
      <slot>Save</slot>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { createAndSaveDocument } from "@/utils/docx-util";

// Props
interface Props {
  filePath: string;
  fileName: string;
  dataSet: any;
}

const props = defineProps<Props>();

// Method
const getDoc = () => {
  createAndSaveDocument(props.fileName, props.filePath, props.dataSet);
};

// If you need to expose methods to parent component
defineExpose({
  getDoc,
});
</script>
